import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { translations } from "@/translations";

i18n.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: Object.fromEntries(
			Object.entries(translations).map(([lang, namespaces]) => [lang, { translation: namespaces }]),
		),
		fallbackLng: "en",
		debug: false,
		interpolation: {
			escapeValue: false,
		},
	});

export default i18n;
